<template>
    <input
        ref="inputField"
        v-model="inputTextValue"
        :type="type"
        :name="name"
        :autocomplete="autocomplete"
        @blur="onBlur"
    />
</template>

<script>
export default {
    props: {
        value: {
            type: String,
            required: true
        },
        type: {
            type: String,
            required: true
        },
        name: {
            type: String,
            default: null
        },
        autocomplete: {
            type: String,
            default: "off"
        },
        shouldValidateInput: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            shouldShowLabel: false
        };
    },
    computed: {
        inputTextValue: {
            get() {
                return this.value;
            },
            set(newValue) {
                this.$emit("input", newValue);
            }
        },
        hasTextValue() {
            return (
                this.inputTextValue !== null && this.inputTextValue.length > 0
            );
        },
        hasValue() {
            return this.shouldShowLabel && this.hasTextValue;
        }
    },
    methods: {
        onBlur() {
            this.shouldShowLabel = true;
            this.$emit("validateinput", this.shouldValidateInput);
        }
    }
};
</script>

<style scoped lang="scss">
input {
    border: none;
    width: 100%;
    font: $input-font;
    color: $input-color;
    line-height: 1.6em;
    padding: 0;
    outline: none;

    /* needed for autofill hack */
    background: rgba(0, 0, 0, 0);
}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
    -webkit-transition-delay: 99999s;
}
</style>
